import { Renderer2 } from '@angular/core';
import { DataAccessScreensizeFacade } from '@planone/bau365/data-access-screensize';
import { DocumentRef, WindowRef } from '@planone/shared/util-browser-api';
import { BehaviorSubject, combineLatest, Subject, takeUntil } from 'rxjs';

export class AdvertisementComponent {
  protected size: string | undefined;
  protected locale = 'de';
  protected adTabsLoaded: string[] = [];
  protected rendered: string[] = [];

  protected unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private passedDocument: DocumentRef,
    private passedRenderer2: Renderer2,
    private passedSasScriptsLoaded: BehaviorSubject<boolean>,
    private passedSasScriptsLoading: BehaviorSubject<boolean>,
    private passedWindow: WindowRef,
    private passedScreensizeFacade: DataAccessScreensizeFacade
  ) {
    if (typeof console !== 'undefined') {
      /**
       * When the component is initialized a second time within the current router callstack then
       * various warnings will be thrown stating that the ad container with the corresponding id cannot
       * be found. To hide these warnings console.warn is killed here.
       *
       * TODO: This may be dirty and nowhere near a best-practise approach. We should either totally remove this
       *   asap allowing warnings to be shown since they don't have a negative effect on the UX or we should
       *   find an alternative way to do this!
       */
      console.warn = () => {
        // Do nothing.
      };
    }

    if (typeof document !== 'undefined') {
      document.write = () => {
        // Do nothing.
      };
    }
  }

  protected initialize() {
    if (!this.passedSasScriptsLoaded.getValue() && !this.passedSasScriptsLoading.getValue()) {
      this.passedSasScriptsLoading.next(true);

      /**
       * Load smart ad server base script synchronously
       */
      this.passedWindow.nativeWindow.sas = this.passedWindow.nativeWindow.sas || {};
      this.passedWindow.nativeWindow.sas.cmd = this.passedWindow.nativeWindow.sas.cmd || [];
      this.passedWindow.nativeWindow.sas.cmd.push(() => {
        this.passedWindow.nativeWindow.sas.setup({
          networkid: 1008,
          domain: 'https://www3.smartadserver.com',
          async: false,
        });
      });

      this.passedSasScriptsLoaded.next(true);
    }
  }

  protected insert(action: (size?: string) => void) {
    if (!this.passedSasScriptsLoaded.getValue()) {
      this.initialize();

      combineLatest(this.passedSasScriptsLoaded, this.passedScreensizeFacade.size$)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([status, size]) => {
          if (status && size) {
            this.size = size;

            action(size);
          }
        });
    } else {
      this.passedScreensizeFacade.size$.pipe(takeUntil(this.unsubscribe)).subscribe((size) => {
        if (size) {
          this.size = size;

          action(size);
        }
      });
    }
  }
}
